import { ElementAttribute } from "../../dom-tools/ElementAttribute";
import { ElementType } from "../../dom-tools/ElementType";
import { SourceRange } from "../../text/lexer/parsing/SourceInfo";
import { RJParser } from "../RJParser";
import { RJExpressionNode } from "./RJExpressionNode";
import { RJExpressionNodeType } from "./RJExpressionNodeType";
import { RJToken } from "./RJToken";


export class BinaryExpression extends RJExpressionNode
{
  operatorToken:RJToken;

  constructor( parser:RJParser, range:SourceRange = null )
  {
    super( parser, RJExpressionNodeType.BINARY, range );
  }

  public setBinary( operatorToken:RJToken, left:RJExpressionNode, right:RJExpressionNode )
  {
    this.operatorToken = operatorToken;
    this._children = [ left, right ];

    left._setParent( this );
    right._setParent( this )
  }

  public get left() { return this._children[ 0 ] };
  public get right() { return this._children[ 1 ] }

  cloneNode():BinaryExpression
  {
    let clone = new BinaryExpression( this.parser, this.sourceRange );
    this._copyExpressionNodeData( clone );

    clone.setBinary( this.operatorToken.cloneNode(), clone.left, clone.right );
    return clone;
  }

  static readonly operatorAttribute = new ElementAttribute( "operator-token" );

  createHTMLElement():Element
  {   
    let element = this._createRawHTMLElement();

    BinaryExpression.operatorAttribute.to( element, this.operatorToken.match );

    let leftElement  = new ElementType( "rj-left" ).create(  this.left.createHTMLElement() );
    let rightElement = new ElementType( "rj-right" ).create(  this.right.createHTMLElement() );

    element.appendChild( leftElement );
    element.appendChild( rightElement );

    return element;
  }
}